import React, { Component } from 'react';
import { ListGroup, ListGroupItem, Navbar, NavbarBrand } from 'reactstrap';
import MyForm from "./MyForm";

class Category extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activeArticle: null
    }
  }

  setActiveArticle(activeArticle) {
    if (activeArticle === this.state.activeArticle) {
      activeArticle = null;
    }
    this.setState({ activeArticle }, () => {
      if (activeArticle) {
        window.scroll(0, document.querySelector('.articles .active').offsetTop);
      }
    });
  }

  render() {
    const { category, setActiveCategory } = this.props;
    const { activeArticle } = this.state;


    if (activeArticle) {
      activeArticle.body = activeArticle.body.replace(/\n/g,"<br />");
    }

    return (
      <div>
        <Navbar light className="mynavbar">
          <span onClick={setActiveCategory.bind(this, null)} className="navbar-toggler-icon"></span>
          <NavbarBrand>{category.title}</NavbarBrand>
        </Navbar>

        <ListGroup flush className="articles">
          {category && category.articles && category.articles.map((article, key) => <ListGroupItem key={key} className={article === activeArticle && 'active'} >
            <div className="articles__title" onClick={this.setActiveArticle.bind(this, article)} >{article.title}</div>
            {article === activeArticle && <div>
              <br />
              <div dangerouslySetInnerHTML={{ __html: activeArticle.body }} />
              <br />
              {activeArticle.allow_send && <MyForm
                article_id={activeArticle.id}
                allow_message={activeArticle.allow_message}
                allow_screenshot={activeArticle.allow_screenshot}
              ></MyForm>}
            </div>}
          </ListGroupItem>)}
        </ListGroup>
      </div>
    );
  }
}

export default Category;



// WEBPACK FOOTER //
// ./src/Category.js